import PropTypes from 'prop-types';
import classNames from 'classnames';
import { trans } from '@spotahome/soyuz/client';

import './Table.scss';

const DEFAULT_LABEL_KEYS = ['chart.table.month', 'chart.table.average.price'];

const Table = ({
  data,
  valueKey = 'value',
  labelKeys = DEFAULT_LABEL_KEYS,
  formatValue = value => value
}) => {
  const header = [
    { key: 'label', label: trans(labelKeys[0]), customClass: '' },
    {
      key: valueKey,
      label: trans(labelKeys[1]),
      customClass: 'table__cell--right'
    }
  ];

  const getTableChangeClasses = item =>
    classNames('table__change', {
      'table__change--green': item.delta > 0,
      'table__change--red': item.delta < 0
    });

  return (
    <div className="table">
      <div className="table__row table__row--header">
        {header.map(({ label, customClass }, index) => (
          <div className={`table__cell ${customClass}`} key={`header-${index}`}>
            {label}
          </div>
        ))}
      </div>

      {data.map((row, rowIndex) => (
        <div className="table__row" key={`row-${rowIndex}`}>
          {header.map(({ key, label, customClass }, colIndex) => {
            const value = key === valueKey ? formatValue(row[key]) : row[key];
            const showDelta = key === valueKey && row.delta;

            return (
              <div
                className={`table__cell ${customClass}`}
                key={`cell-${rowIndex}-${colIndex}`}
                data-label={label}
              >
                {showDelta ? (
                  <>
                    {value}
                    <span className={getTableChangeClasses(row)}>
                      ({row.delta}%)
                    </span>
                  </>
                ) : (
                  value
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

Table.propTypes = {
  valueKey: PropTypes.string,
  labelKeys: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      delta: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ).isRequired,
  formatValue: PropTypes.func
};

export default Table;
